import $ from "jquery";
export function $$(input) {
  if (typeof input === "string") {
    var WC_Shadow = document.querySelector("or-widget")
      ? document.querySelector("or-widget").shadowRoot
      : null;

    var element = WC_Shadow ? WC_Shadow.querySelectorAll(input) : input;

    return $(element);
  } else return $(input);
}
